import React from 'react';
import { ScrollView, View } from 'react-native';

import { capitalize as _capitalize } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Badge } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import OrderSummaryData from '../OrderSummaryData';

import styles from './OrderSummaryDataModal.Styles';

const OrderSummaryDataModal = props => {
  const theme = useTheme();
  const { order } = props;
  const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

  const getOrderItemSummaryData = orderData => {
    return [
      {
        key: 'my_orders_summary_upfront',
        value: `${currencyTransformer(orderData.pricePlan.upfront, 0)}${order.pricePlan.unit}`,
      },
      {
        key: ContentManager.translate('my_orders_summary_total_to_pay_monthly', [
          order.pricePlan.perMonth,
        ]),
        value: `${currencyTransformer(orderData.pricePlan.perMonth, 0)}${order.pricePlan.unit}`,
      },
      {
        key: 'my_orders_summary_total_device_cost',
        value: `${currencyTransformer(
          orderData.pricePlan.totalAmount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'),
          0,
        )}${order.pricePlan.unit}`,
        keyStyle: styles.deviceTotalCost,
        valueStyle: styles.deviceTotalCost,
      },
    ];
  };

  return (
    <>
      <View style={styles.container}>
        <VFText type={'primary'} style={styles.sectionTitle} i18nKey={'my_orders_order_number'} />
        <View style={styles.orderNumContainer}>
          <VFText type={'primary'} style={styles.orderNumber} i18nKey={order.id?.toString()} />
          <Badge
            text={_capitalize(order.state)}
            type="neutral"
            style={styles.badgeStyle}
            textStyle={styles.badgeTextStyle}
          />
        </View>
      </View>

      <ScrollView style={styles.scrollView}>
        {order.items.map((orderData, index) => (
          <OrderSummaryData
            key={index}
            icon={orderData.image}
            title={orderData.category}
            subTitle={orderData.title}
            details={getOrderItemSummaryData(orderData)}
          />
        ))}
      </ScrollView>

      <VFText style={styles.totalPayText} i18nKey={'my_orders_summary_total_to_pay'} />
      <View style={styles.totalPayContent}>
        <View style={styles.separator(theme)} />
        <View style={styles.totalPayContentRow}>
          <VFText style={styles.contentText} i18nKey={'my_orders_summary_upfront'} />
          <VFText
            style={styles.contentText}
            i18nKey={`${currencyTransformer(order.pricePlan.upfront, 0)}${order.pricePlan.unit}`}
          />
        </View>
        <View style={[styles.totalPayContentRow]}>
          <VFText
            style={styles.contentText}
            i18nKey={ContentManager.translate('my_orders_summary_total_to_pay_monthly_total', [
              order.pricePlan.perMonth,
            ])}
          />
          <VFText
            style={styles.contentText}
            i18nKey={`${currencyTransformer(order.pricePlan.monthsCount, 0)}${
              order.pricePlan.unit
            }`}
          />
        </View>
      </View>
    </>
  );
};
OrderSummaryDataModal.propTypes = {
  order: PropTypes.object,
};
export default OrderSummaryDataModal;
